module.exports = __webpack_public_path__ + "img/hewettt.77344b4f.jpg";